numUtil = require('resources/assets/coffee/Core/utils/number')
arrUtil = require('resources/assets/coffee/Core/utils/array')

# not to be confused with ko.utils...
knockoutUtil = exports

knockoutUtil.constrainValues = (lower, higher, increment = 1, allow_equal = true) ->
    # - lower can be an observable value or a regular number
    # - higher can be an observable value or a regular number
    # - increment is a regular number representing  the amount the values
    #     can increase by, default 1 (meaning the values must be integers)

    # add a subscription to the lower value, if it's an observable value
    if ko.isObservable(lower)

        lower.subscribe (lower_val) =>
            lower_val = parseInt(lower_val)

            # don't require the value to be entered
            if numUtil.notSet(lower_val)
                return

            # make sure the lower value is less than the higher value
            higher_val = ko.utils.unwrapObservable(higher)

            if numUtil.notSet(higher_val) or
                    lower_val > higher_val or
                    (lower_val is higher_val and not allow_equal)

                if ko.isObservable(higher) and not ko.isComputed(higher)
                    # if higher is observable, increase it appropriately
                    # based on the new lower value
                    if allow_equal
                        new_higher_val = lower_val
                    else
                        new_higher_val = lower_val + increment
                    higher(new_higher_val)

                else
                    # can't increase the higher value so decrease lower instead
                    if allow_equal
                        new_lower_val = higher_val
                    else
                        new_lower_val = higher_val - increment
                    lower(new_lower_val)


    # add a subscription to the higher value, if it's an observable value
    if ko.isObservable(higher)

        higher.subscribe (higher_val) =>
            higher_val = parseInt(higher_val)

            # don't require the value to be entered
            if numUtil.notSet(higher_val)
                return

            # make sure the higher value is less than the lower value
            lower_val = ko.utils.unwrapObservable(lower)

            if numUtil.notSet(lower_val) or
                    higher_val < lower_val or
                    (higher_val is lower_val and not allow_equal)

                if ko.isObservable(lower) and not ko.isComputed(lower)
                    # if lower is observable, decrease it appropriately
                    # based on the new higher value
                    if allow_equal
                        new_lower_val = higher_val
                    else
                        new_lower_val = higher_val - increment
                    lower(new_lower_val)

                else
                    # can't decrease the lower value so increase higher instead
                    if allow_equal
                        new_higher_val = lower_val
                    else
                        new_higher_val = lower_val + increment
                    higher(new_higher_val)


knockoutUtil.constrainToRange = (observable, range) ->

    observable.subscribe (val) =>
        val = parseInt(val)

        if numUtil.notSet(val)
            return

        # get the range
        range_arr = ko.utils.unwrapObservable(range)

        # make sure the value falls within the range
        # if it does not, use the closest value
        if range_arr.length and val not in range_arr
            closest = arrUtil.closest(range_arr, val)
            if closest?
                observable(closest)

    # add a subscription to re-check the value if the range changes, if it's an observable array
    if ko.isObservable(range)
        range.subscribe () =>
            observable(observable())


knockoutUtil.linkValues = (lower, higher, offset = 1) ->
    # in this function, lower and higher must both be observables
    # if offset is 0, lower and higher are basically interchangeable
    # if offset is > 0, then lower + offset = higher

    # add a subscription to the lower value
    lower.subscribe (lower_val) =>
        lower_val = parseInt(lower_val)

        # don't require the value to be entered
        if numUtil.notSet(lower_val)
            return

        higher_val = parseInt(higher())
        # console.log 'higher_val: '+higher_val
        # console.log 'lower_val+offset: '+(lower_val+offset)
        if higher_val isnt lower_val + offset
            higher( lower_val + offset )


    # add a subscription to the higher value
    higher.subscribe (higher_val) =>
        higher_val = parseInt(higher_val)

        # don't require the value to be entered
        if numUtil.notSet(higher_val)
            return

        lower_val = parseInt(lower())
        # console.log 'lower_val: '+lower_val
        # console.log 'higher_val-offset: '+(higher_val-offset)
        if lower_val isnt higher_val - offset
            lower( higher_val - offset )
